import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/data/services";
import { SectionHead, Reveal } from "@/components/ui/motion";
import { waLink } from "@/lib/config";

const Actions = ({ s }) => (
  <div className="mt-8 flex flex-wrap items-center gap-3">
    <a href={waLink(s.key)} target="_blank" rel="noopener noreferrer" className="btn btn-sky" data-testid={`service-wa-${s.key}`}>
      {s.cta} <ArrowUpRight size={16} />
    </a>
    <Link to={`/layanan/${s.slug}`} className="link-u text-sm font-semibold text-slateb" data-testid={`service-link-${s.key}`}>Lihat detail layanan</Link>
  </div>
);

const Feature = ({ s }) => (
  <article className="card group relative flex h-full flex-col overflow-hidden lg:row-span-2" data-testid={`service-card-${s.key}`}>
    <div className="relative m-3 aspect-[16/10] overflow-hidden rounded-[1.1rem] lg:aspect-auto lg:flex-1">
      <img src={s.image} alt={s.imageAlt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.06]" />
      <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1.5 text-[12px] font-bold text-slateb backdrop-blur">{s.index} — {s.short}</span>
    </div>
    <div className="p-6 sm:p-9">
      <h3 className="font-display text-2xl font-bold leading-tight sm:text-[32px]">{s.headline}</h3>
      <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-ink">{s.description}</p>
      <ul className="mt-6 grid gap-3 sm:grid-cols-2">
        {s.points.map((p) => (
          <li key={p} className="flex gap-2.5 text-[14px] leading-snug text-ink">
            <Check size={16} className="mt-0.5 shrink-0 text-accentb" strokeWidth={2.5} />{p}
          </li>
        ))}
      </ul>
      <Actions s={s} />
    </div>
  </article>
);

const Compact = ({ s }) => (
  <article className="card group relative grid h-full overflow-hidden sm:grid-cols-[1fr_38%]" data-testid={`service-card-${s.key}`}>
    <div className="flex flex-col p-6 sm:p-8">
      <span className="font-display text-sm font-bold text-accentb">{s.index} — {s.short}</span>
      <h3 className="mt-4 font-display text-xl font-bold leading-tight sm:text-2xl">{s.headline}</h3>
      <p className="mt-3 text-[15px] leading-relaxed text-ink">{s.description}</p>
      <div className="mt-auto"><Actions s={s} /></div>
    </div>
    <div className="relative order-first m-3 aspect-[16/9] overflow-hidden rounded-[1.1rem] rounded-tr-[5rem] sm:order-none sm:ml-0 sm:aspect-auto">
      <img src={s.image} alt={s.imageAlt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.08]" />
    </div>
  </article>
);

export const ServicesBento = () => (
  <section id="layanan" className="py-20 sm:py-28 lg:py-36" data-testid="services-section">
    <div className="wrap">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <SectionHead
          eyebrow="Layanan Utama"
          title={<>Temukan Pendampingan yang <span className="serif-it font-normal text-accentb">Sesuai</span> dengan Kebutuhan Anda.</>}
          desc="Setiap kondisi kewajiban finansial memiliki karakteristik berbeda. Kenali layanan Mika Solution untuk memahami pilihan penyelesaian yang mungkin tersedia."
        />
      </div>
      <div className="mt-14 grid grid-cols-1 gap-5 lg:mt-20 lg:grid-cols-12 lg:grid-rows-2">
        <Reveal className="lg:col-span-7 lg:row-span-2"><Feature s={SERVICES[0]} /></Reveal>
        <Reveal className="lg:col-span-5" delay={0.08}><Compact s={SERVICES[1]} /></Reveal>
        <Reveal className="lg:col-span-5" delay={0.16}><Compact s={SERVICES[2]} /></Reveal>
      </div>
    </div>
  </section>
);
